// extracted by mini-css-extract-plugin
export default {"timeUnit":"QROGTLvab69QqZ0xqkmE","value":"GkpobeLnX08u88G3Hnk5"};